import { render, staticRenderFns } from "./FeatureTagsWebsiteSort.vue?vue&type=template&id=2317234c&scoped=true&lang=pug"
import script from "./FeatureTagsWebsiteSort.vue?vue&type=script&lang=js"
export * from "./FeatureTagsWebsiteSort.vue?vue&type=script&lang=js"
import style0 from "./FeatureTagsWebsiteSort.vue?vue&type=style&index=0&id=2317234c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2317234c",
  null
  
)

export default component.exports